import noop from 'lodash/noop';
import {createContext} from 'react';

export const ModalContext = createContext({
    size: 'medium',
    open: false,
    onClose: noop,
});
